import { createContext, useContext, useState, useEffect } from "react";
import { organizatorService } from "../service/Organizator";
import { budowniczyService } from "../service/Budowniczy";


export const DataContext = createContext(null);

export const DataContextProvider = ({ children }) => {
  const [budowniczyArray, setBudowniczyArray] = useState([]);
  const [organizatorArray, setOrganizatorArray] = useState([]);
  const kategorie = [
    'TD',
    'TM',
    'TJ',
    'TU',
    'TZ',
    'TT',
    'TP'
  ];

  useEffect(() => {
    organizatorService.getList().then((data) => {
      if (data && data.status == 'success') {
        setOrganizatorArray(data.data);
      }
    });
    budowniczyService.getList().then((data) => {
      if (data && data.status == 'success') {
        setBudowniczyArray(data.data);
      }
    });
  }, []);

  return <DataContext.Provider value={{ budowniczyArray, organizatorArray, kategorie }}>{children}</DataContext.Provider>
}

export const useDataContext = () => {
  const ctxt = useContext(DataContext);
  if (!ctxt) {
    throw new Error('Provider for DataContext was not specified or context is used out of scope');
  }
  return ctxt;
}